<template>
  <BLayoutView
    :title="pageTitle"
  >
    <v-row>
      <v-col cols="12" md="6">
        <DashboardChartLogins
          :list="logins"
          :loading="isLoadingLogins"
          height="200px"
        />
      </v-col>

      <v-col cols="12" md="6">
        <DashboardChartSessions
          :list="sessions"
          :loading="isLoadingSessions"
          height="200px"
        />
      </v-col>
    </v-row>
    <v-row v-if="canRunTasks">
      <v-col cols="12" md="6">
        <DashboardAsyncTasks
          :loading="isLoadingAsyncTasks"
          :list="asyncTasks"
          @onTaskRunClick="onTaskRunClick"
        />
      </v-col>
    </v-row>
  </BLayoutView>
</template>

<script>
import { DashboardModel as Model } from './Model'
import { dashboardAuthMapper as StoreMapper } from './store'
import { authAsyncTasksPermissions as Permissions } from '@/helpers/enums/permission-models'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import DashboardAsyncTasks from './components/DashboardAsyncTasks.vue'
import DashboardChartLogins from './components/DashboardChartLogins.vue'
import DashboardChartSessions from './components/DashboardChartSessions.vue'


export default {
  name: 'ViewDashboardAuthIndex',
  components: {
    BLayoutView,
    DashboardAsyncTasks,
    DashboardChartLogins,
    DashboardChartSessions,
  },
  data() {
    return {
      isLoading: false,
      isLoadingAsyncData: false,
      isLoadingAsyncTasks: false,
      isLoadingLogins: false,
      isLoadingSessions: false,
      pageTitle: Model.page_title.index,
    }
  },
  computed: {
    ...StoreMapper.mapState(['logins', 'sessions', 'asyncTasks']),
    canRunTasks() {
      return this.$access(Permissions.edit)
    },
  },
  methods: {
    ...StoreMapper.mapActions(['getLogins', 'getSessions', 'getAsyncTasks', 'runAsyncTask']),

    asyncData() {
      return this.onGetData()
    },

    async onGetData(params, isLoading = true) {
      this.isLoadingAsyncData = isLoading

      const actions = [
        this.onGetLogins(),
        this.onGetSessions(),
      ]
      if (this.canRunTasks) {
        actions.push(this.onGetAsyncTasks())
      }

      try {
        await Promise.all(actions)
        return void 0
      } catch (e) {
        const message = Model.response_error.list
        this.$notice.errors(e, { message })
        return Promise.reject(e)
      } finally {
        this.isLoadingAsyncData = false
      }
    },
    async onGetLogins() {
      this.isLoadingLogins = true

      try {
        await this.getLogins()
      } finally {
        this.isLoadingLogins = false
      }
    },
    async onGetSessions() {
      this.isLoadingSessions = true

      try {
        await this.getSessions()
      } finally {
        this.isLoadingSessions = false
      }
    },
    async onGetAsyncTasks() {
      this.isLoadingAsyncTasks = true

      try {
        await this.getAsyncTasks()
      } finally {
        this.isLoadingAsyncTasks = false
      }

      this.isLoadingAsyncTasks = false
    },
    async onTaskRunClick(name) {
      this.isLoadingAsyncTasks = true

      try {
        await this.runAsyncTask(name)
      } finally {
        this.isLoadingAsyncTasks = false
      }

      this.isLoadingAsyncTasks = false
    },
  },
}
</script>
